"use strict";

var _interopRequireDefault = require("/www/wwwroot/deduct_node/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/www/wwwroot/deduct_node/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _user = require("@/api/user");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var defaultConfig = {
  id: '',
  shop_id: 0,
  alipay_user: "",
  alipay_login: '',
  remark: ''
};
var _default = exports.default = {
  data: function data() {
    return {
      config: defaultConfig,
      configList: {},
      listLoading: true,
      dialogVisible: false,
      dialogType: "new"
    };
  },
  computed: {},
  created: function created() {
    this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _user.getWithAlipay)({
        shop_id: this.$user.data.shop
      }).then(function (response) {
        if (response.data) {
          _this.configList = response.data;
        }
        _this.listLoading = false;
      });
    },
    handleAddConfig: function handleAddConfig() {
      var _this2 = this;
      this.config = Object.assign({}, defaultConfig);
      this.config.shop_id = this.$user.data.shop;
      this.dialogType = "new";
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs["Form"].clearValidate();
      });
    },
    handleEditStatus: function handleEditStatus(scope) {
      var _this3 = this;
      // console.log(scope)
      (0, _user.updateWithAlipatStatus)({
        id: scope.row.id,
        shop_id: this.$user.data.shop
      }).then(function (res) {
        _this3.getList();
        _this3.dialogVisible = false;
        _this3.$message({
          message: "编辑成功",
          type: "success"
        });
      });
    },
    // 确认新增或编辑
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
        var _this4 = this;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  (0, _user.createWithAlipay)(_this4.config).then(function (res) {
                    _this4.getList();
                    _this4.dialogVisible = false;
                    _this4.$message({
                      message: "新增成功",
                      type: "success"
                    });
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }()
  }
};